import { TextField } from '@material-ui/core';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import React from 'react';
import {
	renderChargesTypeDefaultValue,
	renderDebitCreditDefaultValue,
	renderProperCase,
	renderRevenueDefaultValue,
} from './Common';

export const OcBill = ({ state, dispatch, outlet }) => {
	let majorAndTax = state?.ocCharges?.filter(
		charge =>
			charge?.descriptionType === 'Major' ||
			charge?.descriptionType === 'OutletTaxPolicy',
	);
	let discAndPayment = state?.ocCharges?.filter(
		charge =>
			charge?.descriptionType === 'DiscountType' ||
			charge?.descriptionType === 'DiscountTaxType' ||
			charge?.descriptionType === 'DiscountServiceChargeType' ||
			charge?.descriptionType === 'PaymentType',
	);
	return (
		<>
			<TableRow className="mapping-tr">
				<TableCell
					scope="row"
					style={{ boxShadow: '7px 0px 10px -8px rgba(138, 138, 138, 0.66)' }}
				>
					<span className="xsTitle ">Officer Check Bill</span>
				</TableCell>
				<TableCell align="left">
					<span className="xsTitle title-row">-</span>
				</TableCell>
				<TableCell align="left">
					<span className="xsTitle  title-row">-</span>{' '}
				</TableCell>
				<TableCell align="left">
					<span className="xsTitle title-row">-</span>{' '}
				</TableCell>
				<TableCell align="left">
					<span className="xsTitle title-row">-</span>
				</TableCell>
				<TableCell align="left">
					<span className="xsTitle title-row">-</span>
				</TableCell>
			</TableRow>
			{majorAndTax?.map((row, i) => (
				<TableRow className="mapping-tr" key={i}>
					<TableCell
						scope="row"
						style={{ boxShadow: '7px 0px 10px -8px rgba(138, 138, 138, 0.66)' }}
					>
						{'OC ' + renderProperCase(row?.description, row?.descriptionType)}
					</TableCell>
					<TableCell align="left">
						{state?.mode === 'edit' ? (
							row?.outletOCGLAccount?.revenueDiv ||
							renderRevenueDefaultValue(
								row?.descriptionType,
								'Division',
								outlet,
							)
						) : (
							<TextField
								id="outlined-basic"
								value={majorAndTax?.[i]?.outletOCGLAccount?.revenueDiv}
								placeholder={renderRevenueDefaultValue(
									row?.descriptionType,
									'Division',
									outlet,
								)}
								className="mapping-textfield"
								variant="outlined"
								onChange={event => {
									const cleaned = event?.target?.value.replace(/\s+/g, "");
                     console.log(cleaned, "cleaned"); // should have no spaces
									const newArr: any = state?.ocCharges;
									let selected = newArr[i]?.outletOCGLAccount;
									selected.revenueDiv = cleaned;

									dispatch({
										type: 'ocCharges',
										payload: newArr,
									});
								}}
							/>
						)}
					</TableCell>
					<TableCell align="left">
						{state?.mode === 'edit' ? (
							row?.outletOCGLAccount?.revenueDept ||
							renderRevenueDefaultValue(
								row?.descriptionType,
								'Department',
								outlet,
							)
						) : (
							<TextField
								id="outlined-basic"
								value={majorAndTax?.[i]?.outletOCGLAccount?.revenueDept}
								placeholder={
									row?.outletOCGLAccount?.revenueDept ||
									renderRevenueDefaultValue(
										row?.descriptionType,
										'Department',
										outlet,
									)
								}
								className="mapping-textfield"
								variant="outlined"
								onChange={event => {
									const cleaned = event?.target?.value.replace(/\s+/g, "");
                     console.log(cleaned, "cleaned"); // should have no spaces
									const newArr: any = state?.ocCharges;
									let selected = newArr[i]?.outletOCGLAccount;
									selected.revenueDept = cleaned;

									dispatch({
										type: 'ocCharges',
										payload: newArr,
									});
								}}
							/>
						)}
					</TableCell>
					<TableCell align="left">{row?.outletGLAccount?.type}</TableCell>
					<TableCell
						align="left"
						style={{
							backgroundColor: '#f5f5f5',
						}}
					></TableCell>
					<TableCell align="left">
						{state?.mode === 'edit' ? (
							row?.outletOCGLAccount?.revenueCredit ||
							`${renderProperCase(
								row?.description,
								row?.descriptionType,
							)} Revenue`
						) : (
							<TextField
								id="outlined-basic"
								value={majorAndTax?.[i]?.outletOCGLAccount?.revenueCredit}
								placeholder={`${renderProperCase(
									row?.description,
									row?.descriptionType,
								)} Revenue`}
								className="mapping-textfield"
								variant="outlined"
								onChange={event => {
									const cleaned = event?.target?.value.replace(/\s+/g, "");
                     console.log(cleaned, "cleaned"); // should have no spaces
									const newArr: any = state?.ocCharges;
									let selected = newArr[i]?.outletOCGLAccount;
									selected.revenueCredit = cleaned;

									dispatch({
										type: 'ocCharges',
										payload: newArr,
									});
								}}
							/>
						)}
					</TableCell>
				</TableRow>
			))}
			{discAndPayment?.map((row, i) => (
				<TableRow className="mapping-tr" key={i}>
					<TableCell
						scope="row"
						style={{ boxShadow: '7px 0px 10px -8px rgba(138, 138, 138, 0.66)' }}
					>
						{'OC ' + renderProperCase(row?.description, row?.descriptionType)}
					</TableCell>
					<TableCell align="left">
						{row?.descriptionType === 'PaymentType' ? (
							state?.mode === 'edit' ? (
								row?.outletGLAccount?.revenueDiv ||
								renderRevenueDefaultValue(
									row?.descriptionType,
									'Division',
									outlet,
								)
							) : (
								<TextField
									id="outlined-basic"
									value={discAndPayment?.[i].outletGLAccount?.revenueDiv}
									placeholder={renderRevenueDefaultValue(
										row?.descriptionType,
										'Division',
										outlet,
									)}
									className="mapping-textfield"
									variant="outlined"
									onChange={event => {
										const cleaned = event?.target?.value.replace(/\s+/g, "");
                     console.log(cleaned, "cleaned"); // should have no spaces
										const newArr: any = state?.ocCharges;
										let selected =
											newArr[i + majorAndTax?.length]?.outletGLAccount;
										selected.revenueDiv = cleaned;

										dispatch({
											type: 'ocCharges',
											payload: newArr,
										});
									}}
								/>
							)
						) : null}
						{row?.descriptionType === 'DiscountType' ||
						row?.descriptionType === 'DiscountTaxType' ||
						row?.descriptionType === 'DiscountServiceChargeType' ? (
							state?.mode === 'edit' ? (
								row?.outletOCDiscountGLAcct?.revenueDiv ||
								renderRevenueDefaultValue(
									row?.descriptionType,
									'Division',
									outlet,
								)
							) : (
								<TextField
									id="outlined-basic"
									value={discAndPayment?.[i].outletOCDiscountGLAcct?.revenueDiv}
									placeholder={renderRevenueDefaultValue(
										row?.descriptionType,
										'Division',
										outlet,
									)}
									className="mapping-textfield"
									variant="outlined"
									onChange={event => {
										const cleaned = event?.target?.value.replace(/\s+/g, "");
                     console.log(cleaned, "cleaned"); // should have no spaces
										const newArr: any = state?.ocCharges;
										let selected =
											newArr[i + majorAndTax?.length]?.outletOCDiscountGLAcct;
										selected.revenueDiv = cleaned;

										dispatch({
											type: 'ocCharges',
											payload: newArr,
										});
									}}
								/>
							)
						) : null}
					</TableCell>
					<TableCell align="left">
						{row?.descriptionType === 'PaymentType' ? (
							state?.mode === 'edit' ? (
								row?.outletGLAccount?.revenueDept ||
								renderRevenueDefaultValue(
									row?.descriptionType,
									'Department',
									outlet,
								)
							) : (
								<TextField
									id="outlined-basic"
									value={discAndPayment?.[i]?.outletGLAccount?.revenueDept}
									placeholder={renderRevenueDefaultValue(
										row?.descriptionType,
										'Department',
										outlet,
									)}
									className="mapping-textfield"
									variant="outlined"
									onChange={event => {
										const cleaned = event?.target?.value.replace(/\s+/g, "");
                     console.log(cleaned, "cleaned"); // should have no spaces
										const newArr: any = state?.ocCharges;
										let selected =
											newArr[i + majorAndTax?.length]?.outletGLAccount;
										selected.revenueDept = cleaned;

										dispatch({
											type: 'ocCharges',
											payload: newArr,
										});
									}}
								/>
							)
						) : null}
						{row?.descriptionType === 'DiscountType' ||
						row?.descriptionType === 'DiscountTaxType' ||
						row?.descriptionType === 'DiscountServiceChargeType' ? (
							state?.mode === 'edit' ? (
								row?.outletOCDiscountGLAcct?.revenueDept ||
								renderRevenueDefaultValue(
									row?.descriptionType,
									'Department',
									outlet,
								)
							) : (
								<TextField
									id="outlined-basic"
									value={
										discAndPayment?.[i]?.outletOCDiscountGLAcct?.revenueDept
									}
									placeholder={renderRevenueDefaultValue(
										row?.descriptionType,
										'Department',
										outlet,
									)}
									className="mapping-textfield"
									variant="outlined"
									onChange={event => {
										const cleaned = event?.target?.value.replace(/\s+/g, "");
                     console.log(cleaned, "cleaned"); // should have no spaces
										const newArr: any = state?.ocCharges;
										let selected =
											newArr[i + majorAndTax?.length]?.outletOCDiscountGLAcct;
										selected.revenueDept = cleaned;

										dispatch({
											type: 'ocCharges',
											payload: newArr,
										});
									}}
								/>
							)
						) : null}
					</TableCell>
					<TableCell align="left">
						{row?.descriptionType === 'DiscountType' ||
						row?.descriptionType === 'DiscountTaxType' ||
						row?.descriptionType === 'DiscountServiceChargeType'
							? row?.outletOCDiscountGLAcct?.type
							: row?.outletGLAccount?.type}
					</TableCell>
					<TableCell align="left">
						{row?.descriptionType === 'PaymentType' ? (
							state?.mode === 'edit' ? (
								row?.outletGLAccount?.revenueDebit ||
								renderProperCase(
									renderDebitCreditDefaultValue(row?.description),
									row?.descriptionType,
								)
							) : state?.mode === 'save' ? (
								<TextField
									id="outlined-basic"
									value={discAndPayment?.[i]?.outletGLAccount?.revenueDebit}
									placeholder={renderProperCase(
										renderDebitCreditDefaultValue(row?.description),
										row?.descriptionType,
									)}
									className="mapping-textfield"
									variant="outlined"
									onChange={event => {
										const cleaned = event?.target?.value.replace(/\s+/g, "");
                     console.log(cleaned, "cleaned"); // should have no spaces
										const newArr: any = state?.ocCharges;
										let selected =
											newArr[i + majorAndTax?.length]?.outletGLAccount;
										selected.revenueDebit = cleaned;

										dispatch({
											type: 'ocCharges',
											payload: newArr,
										});
									}}
								/>
							) : null
						) : null}
						{row?.descriptionType === 'DiscountType' ||
						row?.descriptionType === 'DiscountTaxType' ||
						row?.descriptionType === 'DiscountServiceChargeType' ? (
							state?.mode === 'edit' ? (
								row?.outletOCDiscountGLAcct?.revenueDebit ||
								renderProperCase(
									renderDebitCreditDefaultValue(row?.description),
									row?.descriptionType,
								)
							) : state?.mode === 'save' ? (
								<TextField
									id="outlined-basic"
									value={
										discAndPayment?.[i]?.outletOCDiscountGLAcct?.revenueDebit
									}
									placeholder={renderProperCase(
										renderDebitCreditDefaultValue(row?.description),
										row?.descriptionType,
									)}
									className="mapping-textfield"
									variant="outlined"
									onChange={event => {
										const cleaned = event?.target?.value.replace(/\s+/g, "");
                     console.log(cleaned, "cleaned"); // should have no spaces
										const newArr: any = state?.ocCharges;
										let selected =
											newArr[i + majorAndTax?.length]?.outletOCDiscountGLAcct;
										selected.revenueDebit = cleaned;

										dispatch({
											type: 'ocCharges',
											payload: newArr,
										});
									}}
								/>
							) : null
						) : null}
					</TableCell>
					<TableCell
						align="left"
						style={{
							backgroundColor: '#f5f5f5',
						}}
					></TableCell>
				</TableRow>
			))}
		</>
	);
};
